import Vue from "vue";
import Vuex from "vuex";

import {
  getProducts,
  getMarketProducts,
  getAllCustomer,
  getBackofficeUserList,
  getAllBookingQueue,
  getBackofficeUser,
} from "../modules/backend";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: "",
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "#1E1E1E", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "#2b2b2b",
    setHorizontalLayout: false, // Horizontal layout
    current_user: { display_name: "", role: null },
    tier_list: [
      { id: 0, title: "Uncommon" },
      { id: 1, title: "Common" },
      { id: 2, title: "Rare" },
      { id: 3, title: "Epic" },
      { id: 4, title: "Legendary" },
    ],
    market_products: [],
    province_list: ["Phuket", "Bangkok"],
    products_list: [],
    customers_list: [],
    backoffice_user: [],

    booking_queue: [],

    status_text: ["Cancel", "Waiting to Confirm", "Done", "Confirm"],
  },
  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
  },
  actions: {

    async fetchCurrentUser() {
      let result = await getBackofficeUser();
      console.log('bkf user store ', result)
      this.state.current_user = result
    },
    async fetchBookingQueue() {
      console.log("Get Booking All List");
      let result = await getAllBookingQueue();
      if (result.length > 0) {
        this.state.booking_queue = result.map((obj) => {
          if (obj.status === 0) {
            return { ...obj, status: "Cancel" };
          }
          if (obj.status === 1) {
            return { ...obj, status: "Waiting to Confirm" };
          }
          if (obj.status === 2) {
            return { ...obj, status: "Confirm" };
          }
          if (obj.status === 3) {
            return { ...obj, status: "Done" };
          }
        });
      } else {
        this.state.booking_queue = [];
      }
    },
    async fetchCustomerList() {
      console.log("Get Custoemr List");
      let result = await getAllCustomer();
      if (result.length > 0) {
        this.state.customers_list = result;
      } else {
        this.state.customers_list = [];
      }
    },
    async fetchBackOfficeUserList() {
      console.log("Get BKF USERS List");
      let result = await getBackofficeUserList();
      console.log("bkf users : ", result);
      if (result.length > 0) {
        this.state.backoffice_user = result;
      } else {
        this.state.backoffice_user = [];
      }
    },
    async fetchProductList() {
      let result = await getProducts();

      console.log(result);
      if (result.length > 0) {
        this.state.products_list = result;
      } else {
        this.state.products_list = [];
      }
    },
    async fetchMarketProduct() {
      console.log("mkt");
      let result = await getMarketProducts();
      console.log(result);
      if (result.length > 0) {
        this.state.market_products = result;
      } else {
        this.state.market_products = [];
      }
    },
  },
  getters: {
    getBookingByStatus: (state) => (status) => {
      console.log(status);

      return state.booking_queue.filter((item) => item.status === status);
    },
    getProductList(state) {
      return state.products_list.map((product) => {
        let tier = "";
        if (product.tier == 0) tier = "Common";
        if (product.tier == 1) tier = "Uncommon";
        if (product.tier == 2) tier = "Rare";
        if (product.tier == 3) tier = "Epic";
        if (product.tier == 4) tier = "Legendary";
        return {
          _id: product._id,
          id: product.id,
          name: product.name,
          agent_name: product.agent_name,
          tier: tier,
          price: product.price,
        };
      });
    },

    getCustomerList(state) {
      return state.customers_list.map((item) => {
        let tier = "";
        if (item.tier == 0) tier = "Common";
        if (item.tier == 1) tier = "Uncommon";
        if (item.tier == 2) tier = "Rare";
        if (item.tier == 3) tier = "Epic";
        if (item.tier == 4) tier = "Legendary";

        let create_date = new Date(item.create_date)
          .toISOString()
          .split("T")[0];
        return {
          ...item,
          customer_name: item.customer_name,
          email: item.email,
          tier: item.tier,
          tier_text: tier,
          // create_date : `${create_date.getFullYear()}-${create_date.getMonth()}-${create_date.getDate()}`
          create_date: create_date,
        };
      });
    },

    getUsersList(state) {
      return state.backoffice_user.map((item) => {
        let role = "";
        if (item.role === 0) role = { id: 0, title: "Super Admin" };
        if (item.role === 1) role = { id: 1, title: "Admin" };
        if (item.role === 2) role = { id: 2, title: "Agent" };
        return {

          ...item,
          create_date: item.create_date.split("T")[0],
          role: role,
          role_name: role.title
        };
      });
    },
    // { "id": "VP1234", "display_name": "Vvips Superadmin", "role": 0, "username": "superadmin", 
    getAgentAndSuperUser(state) {
      return state.backoffice_user.map((bk_user) => {
        if (bk_user.role === 0 || bk_user.role) {
          return {
            id: bk_user.id,
            display_name: bk_user.display_name,
            role: bk_user.role,
            username: bk_user.username,
          }

        }

      })

    }
  },
});
